/**
 * Choosing an elevation tag colour: the palette's colours as chips (the bright blue first — the
 * default — then red, black, purple, orange, teal) and a well for a colour of one's own. The same control sets the
 * default for new maps (Settings) and one map's tags (its Elevations sheet).
 */
import { ELEV_COLORS, elevColor } from '../render/style.ts';
import { h, haptic } from './dom.ts';

export function elevColourPicker(current: string | undefined, onPick: (color: string) => void): HTMLElement {
  let now = current ?? ELEV_COLORS[0]!.key;
  const group = h('div', { class: 'chips elev-colours', role: 'group', 'aria-label': 'Tag colour' });
  const custom = () => now.startsWith('#');
  const well = h('input', { type: 'color', value: custom() ? now : '#005eff', 'aria-label': 'A colour of your own' });
  const wellSwatch = h('span', { class: 'swatch' });
  const wellChip = h('label', { class: 'chip well' }, wellSwatch, 'Your own', well);
  const paint = () => {
    for (const b of group.querySelectorAll<HTMLElement>('.chip[data-c]')) b.setAttribute('aria-pressed', String(b.dataset.c === now));
    wellChip.setAttribute('aria-pressed', String(custom()));
    wellSwatch.style.background = custom() ? elevColor(now) : 'conic-gradient(#e0453d, #f0e442, #5fd36e, #4fd1c5, #5fb4ec, #b08beb, #f28cc6, #e0453d)';
  };
  const pick = (c: string) => {
    now = c;
    paint();
    haptic();
    onPick(c);
  };
  for (const c of ELEV_COLORS) group.append(h('button', { class: 'chip', type: 'button', dataset: { c: c.key }, onClick: () => pick(c.key) }, h('span', { class: 'swatch', style: { background: c.color } }), c.name));
  well.addEventListener('change', () => pick(well.value.toLowerCase()));
  group.append(wellChip);
  paint();
  return group;
}
